import apiClient from "./axios-client";

/**
 * 
 * @returns
 */
export const getUserZoneList = async () => {
  const response = await apiClient.get(`/zone/getZoneByProfile`);
  return response.data;
};

export const getCoinageList = async () => {
  const response = await apiClient.get(`/master/get-denomination`);
  return response.data;
};

export const getCoinageChallonNo = async (body) => {
  // return {
  //   zoneName: "पिंपरी नगर",
  //   receiptDate: "21/07/2024",
  //   chalanNo: 91,
  //   chalanAmount: 2000,
  // };
    const response = await apiClient.post(
      `/receipt/getdetails-for-coinage-chalan`,
      body
    );
    return response.data;
};

export const createCoinageChallan = async (body) => {
  const response = await apiClient.post(`/receipt/create-coinage-chalan`, body);
  return response.data;
};
